import {
  route,
  type RouteApi,
  type RouteSpec,
  string,
} from 'react-router-typesafe-routes';

import {chatsRoutesPath} from './chats/path';
import {contentRoutesPath} from './content/path';
import {crmRoutesPath} from './crm/path';
import {foodDiaryRoutesPath} from './food-diary/path';
import {miscRoutesPath} from './misc/path';
import {practiceRoutesPath} from './practice/path';
import {profileRoutesPath} from './profile/path';
import {publicRoutesPath} from './public/path';
import {questionnairesRoutesPath} from './questionnaires/path';
import {todosRoutesPath} from './todos/path';
import {yourSpaceRoutesPath} from './your-space/path';

export const routerPath = route({
  children: {
    content: contentRoutesPath,
    crm: crmRoutesPath,
    profile: profileRoutesPath,
    yourSpace: yourSpaceRoutesPath,
    ...publicRoutesPath.$,
    ...chatsRoutesPath.$,
    ...miscRoutesPath.$,
    ...practiceRoutesPath.$,
    ...todosRoutesPath.$,
    ...questionnairesRoutesPath.$,
    ...foodDiaryRoutesPath.$,
  },
  path: '',
  searchParams: {
    // for the demo flow
    // @see src/v2/modules/b2c-demo/index.ts
    co: string(),
    color: string(),
    demo: string(),
  },
  state: {
    from: string(),
  },
});

/**
 * All the paths from the router path object.
 *
 * @public
 */
export type RouterPaths = ExtractPaths<(typeof routerPath)['$']>;

type ExtractPaths<T, ParentPath extends string = ''> =
  T extends RouteApi<infer Spec>
    ? Spec extends RouteSpec<infer Path, any, any>
      ? T extends {$: infer Children}
        ?
            | ExtractPaths<Children, JoinPath<ParentPath, Path>>
            | JoinPath<ParentPath, Path>
        : JoinPath<ParentPath, Path>
      : never
    : T extends {[key: string]: any}
      ? ExtractPaths<T[keyof T], ParentPath>
      : never;

type JoinPath<Parent extends string, Child> = Child extends string
  ? Parent extends ''
    ? Child
    : `${Parent}/${Child}`
  : never;
